module.exports = __webpack_public_path__ + "static/media/trashcan.0e621da1.svg";